module.exports = __webpack_public_path__ + "static/media/k2-keyboard-desk.089323db.jpg";